import { errorsFactory } from '../../components/utils';

const FileInfectedError = errorsFactory('NoProcessError');

export default FileInfectedError;
